import React, { memo, useMemo } from "react";
import { Divider, Box, CssBaseline, Drawer } from "@mui/material";
import { LEGACY_VIEW, SIDEBAR_RESULT } from "../../../utils/constants/sidebarConstants";
import SideMenuList from "./child-components/sideMenuList";
import SideBrandInfo from "./child-components/sideBrandInfo";
import { useSelector } from "react-redux";
import { DASHBOARD_RESTRICTED_USERS } from "../../../redux/services/config";

const drawerWidth = 200;

const ResponsiveDrawer = () => {
  const { userdetails } = useSelector((state) => state?.userDetails);
    const { authTokenResponseData } = useSelector((state) => state.authToken);
    console.log("authTokenResponseData", authTokenResponseData?.isLegacyDashboard)
  /**
   * Reorder + inject legacy view when user not restricted
   */
  const updatedSideBarOptions = useMemo(() => {
    const isRestricted = DASHBOARD_RESTRICTED_USERS.includes(authTokenResponseData?.userName);
    const isLegacy =  authTokenResponseData?.isLegacyDashboard || userdetails?.isLegacyDashboard || false;


    if (isRestricted) {
      return SIDEBAR_RESULT;
    }

    // Explicit ordering ensures consistent side menu rendering
    return {

      QUICKACCESS: SIDEBAR_RESULT.QUICKACCESS,
      FLIGHT_SHOP: SIDEBAR_RESULT.FLIGHT_SHOP,
      OPTIMIZE_SHOP: SIDEBAR_RESULT.OPTIMIZE_SHOP,
      ...(isLegacy ? {LEGACY_DASHBOARD : SIDEBAR_RESULT?.LEGACY_DASHBOARD} : {}),
      ...(isRestricted ? {} :LEGACY_VIEW),              // inject legacy menus
      PROFILE: SIDEBAR_RESULT.PROFILE
    };

  }, [authTokenResponseData?.userName, userdetails?.isLegacyDashboard]);

  /**
   * Drawer content
   */
  const drawer = (
    <div className="side-menu no-translate hidden-scroll">
      <SideBrandInfo />
      <Divider />

      {Object.entries(updatedSideBarOptions).map(([key, item], index) => (
        <Box key={key}>
          <SideMenuList id={index} data={item.data} icon={item.icon} />
        </Box>
      ))}
    </div>
  );

  /**
   * Main return
   */
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Box component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="permanent"
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            }
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default memo(ResponsiveDrawer);
